export interface CopyReference {
  source?: unknown;
  textbook?: unknown;
  source_name?: unknown;
  reference?: unknown;
  page_number?: unknown;
  pageNumber?: unknown;
  edition?: unknown;
  details?: {
    page_number?: unknown;
    edition?: unknown;
  };
}

export interface ChatCopyContent {
  answer?: string;
  justification?: string;
  references?: CopyReference[];
  content?: unknown;
}

export const formatChatCopyText = ({
  answer,
  justification,
  references,
  content,
}: ChatCopyContent): string => {
  let copyText = "";

  if (answer) copyText += answer;
  if (justification) {
    copyText += copyText ? "\n\n" : "";
    copyText += justification;
  }

  if (references && references.length > 0) {
    copyText += "\n\nReferences:\n";
    references.forEach((reference, index) => {
      const source =
        reference.source ||
        reference.textbook ||
        reference.source_name ||
        reference.reference ||
        "Source";
      const cleanSource =
        typeof source === "string" ? source.replace(/\.pdf$/i, "") : String(source);
      const page =
        reference.page_number ||
        reference.pageNumber ||
        reference.details?.page_number;
      const edition = reference.edition || reference.details?.edition;
      const metadata = [
        edition ? `Edition: ${edition}` : "",
        page ? `p. ${page}` : "",
      ].filter(Boolean);
      copyText += `${index + 1}. ${cleanSource}${
        metadata.length ? ` (${metadata.join(", ")})` : ""
      }\n`;
    });
  }

  if (!copyText && content) {
    copyText = typeof content === "string" ? content : JSON.stringify(content);
  }

  return `${copyText}\n-\nPowered by C-Shaped | c-shaped.com`;
};

